module.exports = __webpack_public_path__ + "static/media/icon-placard-location-id.5531857e.png";